// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3iQAM","content":"Consent_content__16mAg","footer":"Consent_footer__1T7cx"};